/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback } from "react";
import "./ProductLoanReport.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  FaRupeeSign,
  FaEye,
  FaTimes,
  FaSearch,
  FaFilter,
  FaTable,
  FaChevronLeft,
  FaChevronRight,
  FaFilePdf,
  FaFileExcel,
  FaFileCsv,
  FaIdCard,
} from "react-icons/fa";
import { toast } from "react-toastify";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ProductLoanReport = () => {
  const [loans, setLoans] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // Filter States
  const [filters, setFilters] = useState({
    formNo: "",
    status: "",
    loanDate: "",
  });

  // Image Modal State
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchLoanReport = useCallback(
    async (page = currentPage) => {
      if (!profile?.id) return;
      setLoading(true);
      try {
        const res = await axios.get(
          `https://payyug.in/api/product-loan/report`,
          {
            params: {
              superAdminId: profile.superAdminId || 14,
              employeeId: profile.id,
              page,
              limit: itemsPerPage==="All"?100000:itemsPerPage,
            },
          },
        );

        if (res.data.success) {
          setLoans(res.data.data || []);
          setTotalPages(res.data.totalPages || 1);
        }
      } catch (error) {
        console.error("Fetch error:", error);
        toast.error("Data load karne mein dikkat hui");
      } finally {
        setLoading(false);
      }
    },
    [profile, currentPage,itemsPerPage],
  );

  useEffect(() => {
    fetchLoanReport();
  }, [fetchLoanReport]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
    setCurrentPage(1);
  };

    const handleItemsPerPageChange = (e) => {
    setItemsPerPage(
      e.target.value === "All" ? "All" : Number(e.target.value),
    );
    setCurrentPage(1);
  };

  const handleViewImage = (imagePath) => {
    if (!imagePath) return toast.info("Bill image available nahi hai");
    setSelectedImageUrl(`https://payyug.in/${imagePath}`);
    setShowImageModal(true);
  };

  const handleViewEmi = (loan) =>
    navigate(`/Productloan/ProductLoanEmiDetails/${loan.id}`, {
      state: { loan },
    });

  const handleViewLoanCard = (loan) =>
    navigate(`/ProductLoan/ProductLoanEmiCard/${loan.id}`, { state: { loan } });

  // UI Filtering
  const filteredLoans = loans.filter((loan) => {
    const formMatch =
      !filters.formNo ||
      loan.formNo?.toLowerCase().includes(filters.formNo.toLowerCase());
    const statusMatch =
      !filters.status ||
      loan.status?.toLowerCase() === filters.status.toLowerCase();
    const dateMatch =
      !filters.loanDate || loan.loanDate?.split("T")[0] === filters.loanDate;
    return formMatch && statusMatch && dateMatch;
  });

  // --- Export Functions ---

  const exportExcel = () => {
    const data = filteredLoans.map((loan, index) => ({
      SN: index + 1,
      "Form No": loan.formNo,
      "Customer ID": loan.borrowerId,
      "Customer Name": loan.ref1Name,
      Amount: loan.loanAmount,
      Status: loan.status,
      Date: loan.loanDate?.split("T")[0],
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ProductLoans");
    XLSX.writeFile(workbook, "Product_Loan_Report.xlsx");
  };

  const exportCSV = () => {
    const data = filteredLoans.map((loan, index) => ({
      SN: index + 1,
      "Form No": loan.formNo,
      "Customer ID": loan.borrowerId,
      "Customer Name": loan.ref1Name,
      Amount: loan.loanAmount,
      Status: loan.status,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const csvOutput = XLSX.utils.sheet_to_csv(worksheet);
    const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "Product_Loan_Report.csv");
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Product Loan Report", 14, 15);
    const tableColumn = [
      "SN",
      "Form No",
      "Cust ID",
      "Name",
      "Amount",
      "Status",
    ];
    const tableRows = filteredLoans.map((loan, index) => [
      index + 1,
      loan.formNo,
      loan.borrowerId,
      loan.ref1Name,
      `Rs. ${loan.loanAmount}`,
      loan.status,
    ]);
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
    });
    doc.save("Product_Loan_Report.pdf");
  };

  return (
    <div className="product-loan-report-container">
      <h2 style={{textAlign:"center"}}>Product Loan Report</h2>
      {/* --- Filter Section --- */}
      <section className="product-loan-report-filter-box">
        {/* <div className="product-loan-report-filter-title">
          <FaFilter className="product-loan-report-title-icon" />
          <h3>Product Loan Filters</h3>
        </div> */}
        <div className="product-loan-report-filter-grid">
          <div className="product-loan-report-filter-input-fields">
            <label>Form Number</label>
            <div className="product-loan-report-filter-input-with-icon">
              <FaSearch />
              <input
                type="text"
                placeholder="PL177..."
                value={filters.formNo}
                onChange={(e) => handleFilterChange("formNo", e.target.value)}
              />
            </div>
          </div>
          <div className="product-loan-report-filter-input-fields">
            <label>Status</label>
            <select
              value={filters.status}
              onChange={(e) => handleFilterChange("status", e.target.value)}
            >
              <option value="">All Status</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="disbursed">Disbursed</option>
            </select>
          </div>
          <div className="product-loan-report-filter-input-fields">
            <label>Loan Date</label>
            <input
              type="date"
              value={filters.loanDate}
              onChange={(e) => handleFilterChange("loanDate", e.target.value)}
            />
          </div>
        </div>
      </section>

      {/* --- Table Section --- */}
      <section className="product-loan-report-wrapper">
        <div className="product-loan-report-box-header">
          <div className="product-loan-report-box-header-left">
            <FaTable className="product-loan-report-title-icon" />
            <h3>Loan Records</h3>
             <select
              className="lsr-app-select-limit"
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
            >
              <option value={10}>10 Rows</option>
              <option value={25}>25 Rows</option>
              <option value={50}>50 Rows</option>
              <option value="All">All Records</option>
            </select>
          </div>
          <div className="product-loan-report-box-export-btns">
            <button className="product-loan-report-box-export-btn csv" onClick={exportCSV}>
              <FaFileCsv /> CSV
            </button>
            <button className="product-loan-report-box-export-btn excel" onClick={exportExcel}>
              <FaFileExcel /> Excel
            </button>
            <button className="product-loan-report-box-export-btn pdf" onClick={exportPDF}>
              <FaFilePdf /> PDF
            </button>
          </div>
        </div>

        <div className="product-loan-report-table-container">
          <table className="product-loan-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Bill Image</th>
                <th>Account No</th>
                <th>Customer Id</th>
                <th>Customer Name</th>
                <th>Vendor Price</th>
                <th>Down Payment</th>
                <th>Loan Amount</th>
                <th>Roi</th>
                <th>Tenure</th>
                <th>Emi Amount</th>
                <th>Total Payable</th>
                <th>Status</th>
                <th style={{ textAlign: "center" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="14" className="product-loan-report-table-text-center">
                    Data loading...
                  </td>
                </tr>
              ) : filteredLoans.length > 0 ? (
                filteredLoans.map((item, index) => {
                  const canViewDetails =
                    item.status?.toLowerCase() === "disbursed" ||
                    item.status?.toLowerCase() === "active";
                  return (
                    <tr key={item.id}>
                      <td>{itemsPerPage==="All"?index+1:(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>
                        <button
                          className="product-loan-report-table-view-btn view"
                          title="View Bill"
                          onClick={() => handleViewImage(item.billImage)}
                        >
                          <FaEye />
                        </button>
                      </td>
                      <td className="product-loan-report-table-bold-text">{item.formNo}</td>
                      <td className="product-loan-report-table-bold-text">{item?.customer?.userId}</td>
                      <td className="product-loan-report-table-bold-text">{item?.customer?.fullName}</td>
                      <td>{`₹${item.vendorPrice?.toLocaleString()}`||"N/A"}</td>
                      <td>{`₹${item.downPayment?.toLocaleString()}`||"N/A"}</td>
                      <td className="product-loan-report-table-price-text">
                        {`₹${item.loanAmount?.toLocaleString()}`||"N/A"}
                      </td>
                      <td>{item.roi||"N/A"}</td>
                      <td>{item.term||"N/A"}</td>
                      <td>{`₹${item.emiAmount?.toLocaleString()}`||"N/A"}</td>
                      <td>{`₹${item.totalPayable?.toLocaleString()}`||"N/A"}</td>
                      <td>
                        <span
                          className={`product-loan-report-table-badge product-loan-report-table-badge-${item.status?.toLowerCase()}`}
                        >
                          {item.status}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <div className="product-loan-report-table-action-group">
                          {/* Conditional EMI & Loan Card Buttons */}
                          {canViewDetails ? (
                            <>
                              <button
                                className="product-loan-report-table-view-btn emi"
                                title="EMI Details"
                                onClick={() => handleViewEmi(item)}
                              >
                                <FaRupeeSign />
                              </button>
                              <button
                                className="product-loan-report-table-view-card-btn"
                                title="Loan Card"
                                onClick={() => handleViewLoanCard(item)}
                              >
                                <FaIdCard style={{ marginRight: "4px" }} /> Card
                              </button>
                            </>
                          ) : (
                            <span style={{ color: "#ccc", fontSize: "12px" }}>
                              N/A
                            </span>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="14" className="product-loan-report-table-text-center">
                    No Data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && itemsPerPage !== "All" && (
          <div className="product-loan-report-pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            >
              <FaChevronLeft />
            </button>
            <span>
              Page <strong>{currentPage}</strong> of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)}
            >
              <FaChevronRight />
            </button>
          </div>
        )}
      </section>

      {/* --- Image View Modal --- */}
      {showImageModal && (
        <div
          className="product-loan-report-image-modal-overlay"
          onClick={() => setShowImageModal(false)}
        >
          <div
            className="product-loan-report-image-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="product-loan-report-image-modal-close-btn"
              onClick={() => setShowImageModal(false)}
            >
              <FaTimes />
            </button>
            <div className="product-loan-report-image-modal-container">
              <img
                src={selectedImageUrl}
                alt="Bill"
                className="product-loan-report-image-modal-fulll-image"
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/400?text=Image+Not+Found";
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductLoanReport;
